import React, {useState} from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import Button from '#components/a/Button'
import {Courses} from './Courses'
import AzubiProfile from '../AzubiProfile'
import {routeHelper} from '#config/routeKeys'
import {useNavigate} from 'react-router-dom'

function AzubiWithCourses({user, courses, filteredModules, courseLimit}) {
  const [selectedCourseAndUser, setSelectedCourseAndUser] = useState()
  const navigate = useNavigate()

  const openSingleAzubi = azubiId => {
    navigate(routeHelper.nextPerUser(azubiId))
  }

  return (
    <div key={user.id} className="wissensportal-ausbilder__user">
      <AzubiProfile user={user} onClick={() => openSingleAzubi(user.id)} />
      <div className="wissensportal-ausbilder__user-courses" data-testid={`azubi-courses-${user.id}`}>
        <Courses
          courses={courseLimit ? courses.slice(0, courseLimit) : courses}
          modules={filteredModules}
          onCourseClick={course => {
            if (selectedCourseAndUser && selectedCourseAndUser.courseId === course.id) {
              setSelectedCourseAndUser(null)
            } else {
              setSelectedCourseAndUser({userId: user.id, courseId: course.id})
            }
          }}
          selectedCourseId={selectedCourseAndUser ? selectedCourseAndUser.courseId : null}
          mode="vertical"
        />
        <div className="button-container">
          {courseLimit && courses.length > courseLimit && (
            <Button
              variant="secondary"
              modifiers={['button']}
              text={i18n.t('all_courses')}
              event={() => openSingleAzubi(user.id)}
            />
          )}
        </div>
      </div>
    </div>
  )
}

AzubiWithCourses.propTypes = {
  user: PropTypes.object.isRequired,
  courses: PropTypes.array.isRequired,
  filteredModules: PropTypes.array,
  courseLimit: PropTypes.number,
}

export default AzubiWithCourses
